import { BUTTON_PRESS } from './baseEvents'

const REASONING_TRAIL = 'Reasoning Trail'

export const REASONING_TRAIL_CRITERION_TOGGLE = `${BUTTON_PRESS} ${REASONING_TRAIL} - Criterion Toggle`
export const REASONING_TRAIL_ACCESS_LOGS_LINK = `${BUTTON_PRESS} ${REASONING_TRAIL} - View Access Logs`
export const REASONING_TRAIL_FEEDBACK_THUMB = `${BUTTON_PRESS} ${REASONING_TRAIL} - Feedback Thumb`
export const REASONING_TRAIL_FEEDBACK_COMMENT = `${BUTTON_PRESS} ${REASONING_TRAIL} - Feedback Comment Submit`
